import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filterName' })
export class SplitPipe implements PipeTransform {
    public transform(val: string, params: string[]) {
        if (val) {
            return val.split(' ')[0];
        }
        return null;
    }
}
